import { Controller } from "@hotwired/stimulus"

import { continuousPlayEnabled, setContinuousPlay } from "@/lib/utils"

export default class extends Controller<HTMLButtonElement> {
  connect() {
    this.element.setAttribute("aria-pressed", String(continuousPlayEnabled()))
  }

  toggle() {
    const next = this.element.getAttribute("aria-pressed") !== "true"
    if (!setContinuousPlay(next)) return

    this.element.setAttribute("aria-pressed", String(next))
    this.dispatch("change")
  }
}
